import { createBlockquotePlugin } from '@udecode/plate-block-quote';
import { createCodeBlockPlugin } from '@udecode/plate-code-block';
import { createHeadingPlugin } from '@udecode/plate-heading';
import { createParagraphPlugin } from '@udecode/plate-paragraph';

/**
 * Enables support for basic elements:
 * - Block quote
 * - Code block
 * - Heading
 * - Paragraph
 */
var createBasicElementPlugins = function createBasicElementPlugins() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    heading = _ref.heading;
  return [createBlockquotePlugin(), createCodeBlockPlugin(), createHeadingPlugin(heading), createParagraphPlugin()];
};
export { createBasicElementPlugins };